<template>
  <div :id="uuid" :style="{ width: width + 'px', height: height + 'px' }" />
</template>

<script setup>
import { getDataJson, pollingRefresh,hasNonEmptyValues,hasProperty } from "@/utils/refresh-cpt-data";
import { onMounted, watch, computed } from "vue";
import * as echarts from 'echarts'
import { graphic } from 'echarts'

const props = defineProps({
  width: Number,
  height: Number,
  option: Object,
  show: Boolean,
  components:Array,
  current: Object
})
// 新增属性兼容旧代码
const attr = props.option.attribute
if (!attr.globalDataReload) attr.globalDataReload = [0]

let dataReload = computed(() => props.option.attribute.globalDataReload || [0])
watch(() => props.current.cptShow,(val)=>{
    if (val && dataReload.value.includes(1)) {
      refreshCptData();
    }
  })
  watch(() => props.option.attribute.hideCompInTabw,(val)=>{
    if (!val && dataReload.value.includes(1)) {
      refreshCptData();
    }
  })
// watch(() => props.option.attribute, (obj) => {
//   processData(props.option.cptDataForm,newData,jsFunFlag);
//   loadChart(obj);
// }, { deep: true })
watch(() => [props.width, props.height], () => {
  chart.resize()
})

let uuid = require('uuid').v1();
let chartOption = {};
let chart = null
let cptData = [];
let newData = null;
let jsFunFlag = false;
const emit = defineEmits(['clickHandler'])

onMounted(() => {
  const element = document.getElementById(uuid)
  if(!element) return
  chart = echarts.init(element)
  if (dataReload.value.includes(0)) {
    refreshCptData();
  }
})

function refreshCptData(cptDataForm = props.option.cptDataForm,paras) {
  pollingRefresh(uuid, cptDataForm, () => loadData(cptDataForm,paras),
  props.components)
}
function loadData(cptDataForm,paras) {
  getDataJson(cptDataForm,paras,(res)=> {
      newData = cptDataForm.dataSource == '4' && hasProperty(res,'jsFunction') ? res.resStr : res;//相同数据集只调用一次接口原因
      jsFunFlag = cptDataForm.dataSource == '4' && hasProperty(res,'jsFunction') ? res.jsFunction : false;//相同数据集只调用一次接口原因
      processData(cptDataForm,newData,jsFunFlag)
        // console.log(res,'res*')
        // cptData = res;
       loadChart(props.option.attribute);
    })
}
function processData(cptDataForm,res,jsFunFlag) {
      // 第一层判断 如果选择数据集
    if(cptDataForm.dataSource == '4') {
      // 第二层判断 ，如果没有配转换脚本
      if(jsFunFlag) { // 没有全部配置映射字段
          if(hasNonEmptyValues(props.option.attribute.cptTableData)) {
          const dataKey = props.option.attribute.cptTableData;
        // 创建一个新的数组用于存储结果
          let newres = [];
          let newObj = {...res[0]};
        // 如果dataKey中的value有值并且在newObj对象中有对应的值
          // if (dataKey[0].value && newObj[dataKey[0].value]) {
            newObj[dataKey[0].namekey] = newObj[dataKey[0].value];
          // }
          newres.push(newObj);
          // console.log(newres,'新数组');
          cptData = newres[0]; 
        }
        } else { // 如果配置了转换脚本
          cptData = res;
        }
    } else { // 不是数据集类型，是静态数据
      cptData = res;
    } 
}

function loadChart(attribute) {
  let pointer = JSON.parse(JSON.stringify(attribute.pointer));
  pointer.offsetCenter = [0, attribute.pointerOffsetTop + '%'];
  let itemColor = attribute.itemColor ? attribute.itemColor : 'transparent'
  let axisLineColor = [
    [0.3, attribute.color1],
    [0.7, attribute.color2],
    [1, attribute.color3]
  ];
  if (attribute.enableGradual) {
    axisLineColor = [
      [1, new graphic.LinearGradient(0, 0, 1, 0, [
        { offset: 0, color: attribute.color1 },
        { offset: 0.5, color: attribute.color2 },
        { offset: 1, color: attribute.color3 },
      ]),
      ],
    ]
  }
  chartOption = {
    backgroundColor: '',
    // tooltip: {
    //   formatter: '{a} <br/>{b} : {c}%'
    // },
    series: [
      {
        name: 'Pressure',
        type: 'gauge',
        startAngle: attribute.startAngle,
        endAngle: attribute.endAngle,
        radius: attribute.radius + '%',
        min: attribute.min,
        max: attribute.max,
        axisLabel: attribute.axisLabel,
        axisTick: attribute.axisTick,
        splitLine: {
          show: attribute.axisTick.show,
          distance: attribute.axisTick.distance,
          length: attribute.axisTick.length * 1.5,
          lineStyle: {
            width: attribute.axisTick.lineStyle.width + 1,
            color: attribute.axisTick.lineStyle.color
          }
        },
        axisLine: {
          lineStyle: {
            width: attribute.lineWidth,
            color: axisLineColor
          }
        },
        progress: {
          show: true,
          width: attribute.lineWidth,
        },
        pointer: pointer,
        itemStyle: { color: itemColor },
        title: {
          show: true,
          fontSize: attribute.titleSize,
          color: attribute.titleColor,
          offsetCenter: [0, attribute.titleOffsetTop + '%']
        },
        detail: {
          valueAnimation: true,
          formatter: '{value}',
          color: attribute.detailColor,
          fontSize: attribute.detailSize,
          offsetCenter: [0, attribute.detailOffsetTop + '%']
        },
        data: [
          {
            value: cptData.value,
            name: attribute.title
          }
        ]
      }
    ]
  }

  if (chart) {
    chart.setOption(chartOption, true);

    chart.on('click', (params) => {
      emit("clickHandler", props.option.interaction, 'default', params.name)
    })
  }

}

defineExpose({ refreshCptData })
</script>

<style scoped></style>
